import { useStore } from '@nanostores/react';
import * as RadixDialog from '@radix-ui/react-dialog';
import { useCallback } from 'react';
import { PlanBlock } from './PlanBlock';
import { Summary } from './Summary';
import { Dialog, DialogContent, DialogHeader } from '~/components/ui/Dialog';
import { IconButton } from '~/components/ui/IconButton';
import { pricingStore } from '~/lib/stores/pricing/pricing';

interface UpdatePlanScreenDialogProps {
  open: boolean;
}

export const UpdatePlanScreenDialog = ({ open }: UpdatePlanScreenDialogProps) => {
  const updatePlanScreenData = useStore(pricingStore.updatePlanScreenData);

  const onClose = useCallback(() => {
    pricingStore.updatePlanScreenData.set(null);
  }, []);

  if (!updatePlanScreenData) {
    return null;
  }

  const pricing = updatePlanScreenData.pricing;

  return (
    <Dialog
      open={!!open}
      onClose={onClose}
      maxWidth={1000}
      contentClassName="max-h-90vh overflow-y-auto"
      showCloseButton={false}
    >
      <DialogHeader
        title={
          <div className="w-full flex items-center justify-between gap-2">
            <div className="text-lg font-semibold">Update Subscription</div>
            <RadixDialog.Close asChild onClick={onClose}>
              <IconButton
                size="md"
                variant="ghost"
                icon="i-heroicons:x-mark-solid"
                className="ml-auto absolute top-2 right-2"
                aria-label="Close"
              />
            </RadixDialog.Close>
          </div>
        }
        className="sticky top-0"
      />

      <DialogContent className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-0 justify-center p-10 overflow-y-auto">
        <PlanBlock pricing={pricing} />
        <Summary />
      </DialogContent>
    </Dialog>
  );
};
